import { KeyRound } from '@orgus/ui/icons';
import { TokensView } from '../../auth/TokensView.tsx';
import type { SettingsSection } from '../registry.ts';

const section: SettingsSection = {
  id: 'tokens',
  title: 'API tokens',
  description: 'For scripts, CI and AI agents. Shown once, kept 30 days at most.',
  order: 20,
  group: 'workspace',
  keywords: ['token', 'api', 'ci', 'scripts', 'keys'],
  icon: KeyRound,
  Component: TokensView,
};
export default section;
